import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { LogisticService, StockplaceItem } from '../../../services/logistic.service';

@Component({
  selector: 'tt-order-head-create-ib-purch',
  templateUrl: './order-head-create-ib-purch.component.html',
  styleUrls: ['./order-head-create-ib-purch.component.css']
})
export class OrderHeadCreateIbPurchComponent implements OnInit {
    orderInternalNo;

    public edit?: Edit;

    public selectListStockPlaces: StockplaceItem[] = [];

    public creating = false;

    constructor(private stateService: StateService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.orderInternalNo = this.stateService.getStateParams()['order_internal_no'];
    }

    private async loadEdit() {
        if (!!this.orderInternalNo) {
            this.edit = (await this.datatask.Post(736, { order_internal_no: this.orderInternalNo }))[0];
        }
    }

    private async loadStockPlaces() {
        if (!this.edit) return;

        return this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.edit.businessco_no });
    }

    public async createChanges() {
        if (!!this.edit) {
            try {
                this.creating = true;

                await this.datatask.Post(737, this.edit);

                this.stateService.back();
            } finally {
                this.creating = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadStockPlaces();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    infotext: string;
    order_internal_no: string;
    businessco_no: string;
    businessco_companyname: string;
    stockplace_id: string;
}
